package com.xtream.composeapp.viewmodel.livetv

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.xtream.data_kmp.db.repo.LiveStreamsRepository
import com.xtream.data_kmp.dto.LiveCategory
import com.xtream.data_kmp.dto.LiveStream
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.launch
import kotlinx.coroutines.withContext


class SelectedTVchanelLiveModel (
    private val liveStreamsRepository: LiveStreamsRepository
):ViewModel() {

    var  selectedPosition=MutableStateFlow(0)
    // TODO implement kmp private val  mediaFormat=MutableStateFlow<Format?>(null)

    private val _selectedPositionTemp = MutableStateFlow("")
    val selectedPositionTemp: StateFlow<String> = _selectedPositionTemp.asStateFlow()
    var selectedChannel=MutableStateFlow<LiveStream?>(null)
    private var selectedTvGroup= MutableStateFlow<LiveCategory?>(null)
    private var playingCategory= MutableStateFlow<LiveCategory?>(null)



    fun emitSelectedTvChannel(channel: LiveStream?){
        selectedChannel.tryEmit(channel)
    }
    fun emitSelectedTvChannel(position:Int?, channel: LiveStream?,currentCategory: LiveCategory?=null){

        viewModelScope.launch (Dispatchers.Default) {
        emitPlayingCategory(currentCategory ?: selectedTvGroup.value)

            selectedChannel.value = channel
            selectedPosition.value = position  ?: -1
        }
    }


    suspend fun addSelectedPositionTemp(value:String?){
    val limitIndex= withContext(Dispatchers.Default){selectedCategorySize().toString().length}

    if(value.isNullOrEmpty() ||
        limitIndex ==selectedPositionTemp.value.length||
        (value =="0"&& _selectedPositionTemp.value=="")) return

    _selectedPositionTemp.value+=value
}
    fun resetSelectedPositionTemp(){_selectedPositionTemp.value=""}
    fun emitGroup(tvChannelsGroupsModel: LiveCategory?) {
        viewModelScope.launch {

        selectedTvGroup.emit(tvChannelsGroupsModel)
             }

    }

    fun emitPlayingCategory(tvChannelsGroupsModel: LiveCategory?) {
        playingCategory.tryEmit(tvChannelsGroupsModel)
    }
   suspend fun updateSelectedBy(number:Int,offset:Int=-1){

       liveStreamsRepository.findNextItem(

           //if offset not available then send current position
           if(offset==-1)
               selectedPosition.value
           else offset,
           number,
           playingCategory.value?.categoryId){item, pos->
           emitSelectedTvChannel(pos,item,playingCategory.value)
       }

    }

    private suspend fun selectedCategorySize() = liveStreamsRepository.streamsSize(selectedTvGroup.value?.categoryId)
    /**
     * checks weather the given stream is available in Favorites Table?
     * @property  stream stream item to be checked
     * @return Flow< Boolean> returns true if the stream is in favorites table otherwise false
     **/
    val isFavoriteFlow =
        combine(selectedChannel,
            liveStreamsRepository.isFavoriteAsFlow(selectedChannel.value?.streamId?:-1)) {
            s,f->

            return@combine  if(s==null) false else liveStreamsRepository.isFavorite(s.streamId)

        }.stateIn(
            scope = viewModelScope,
            started = kotlinx.coroutines.flow.SharingStarted.WhileSubscribed(),
            initialValue = false
        )

}


